<template>
    <SJMMall>
        <div class="returnCargoDocWrap">
            <SJMLoading v-if="pageLoading"></SJMLoading>
            <div class="iframeBox">
                <div class="tips">若预览异常，请安装PDF插件或使用Chrome浏览器、360浏览器！</div>
                <iframe ref="iframe"
                        :src="fileView"
                        frameborder="0"
                        scrolling="no"
                        width="800px"
                        height="800px"></iframe>
                <div class="operatingBtnBox">
                    <a :href="fileDownload"
                       download
                       class="operatingLink">
                        <el-button class="operatingBtn">下载</el-button>
                    </a>
                    <!-- <a :href="`/personalCenter/PersonalCenterMain/operationCenter/cargoQuery/exportBusiness/CostConfirm?orderBillCode=${$route.query.orderBillCode}`"
                       target="_blank"
                       class="operatingLink">
                        <el-button class="operatingBtn"
                                   type="primary">
                            {{isCostConfirm === '0' ? '去费用确认' : '已确认费用'}}
                        </el-button>
                    </a> -->
                </div>
            </div>
        </div>
    </SJMMall>
</template>

<script>
    export default {
        name: 'ReturnCargoDoc',// 放货凭证
        data() {
            return {
                pageLoading: false,// 页面loading
                fileView: '',// 文件查看链接
                fileDownload: '',// 文件下载链接
                isCostConfirm: '',// 是否确认费用 0-待费用确认、1-已确认费用
            };
        },
        created() {
            if (!this.$route.query.orderBillCode) {
                this.$Alert({
                    msg: '非法访问'
                });
                return;
            }
            // 获取商城订单状态退货申请放货单的数据
            this.getMallOrderStatusReturnCargoDocData();
        },
        methods: {
            // 获取商城订单状态退货申请放货单的数据
            getMallOrderStatusReturnCargoDocData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/exportBusiness/unManned/OrderUnsubscribeHandler.ashx',
                    data: {
                        act: 'getMallOrderStatusReturnCargoDocData',// 获取商城订单状态退货申请放货单的数据
                        orderBillCode: this.$route.query.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.pageLoading = true;
                    },
                    success: (res) => {
                        this.fileView = res.success.fileView;
                        this.fileDownload = res.success.fileDownload;
                        this.isCostConfirm = res.success.isCostConfirm;

                        this.pageLoading = false;
                    }
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
    .returnCargoDocWrap {
        position: relative;
        margin: 0 auto;
        background-color: #f3f3f4;

        .tips {
            margin-bottom: 10px;
            font-size: 16px;
            font-weight: bold;
            color: red;
        }

        .iframeBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 1245px;
            min-width: 1245px;
            padding-top: 50px;
            padding-bottom: 150px;
            margin: 0 auto;
            background-color: white;

            .operatingBtnBox {
                width: 800px;
                margin-top: 70px;
                text-align: right;

                .operatingLink {
                    margin-right: 30px;

                    &:last-child {
                        margin-right: 0;
                    }

                    .operatingBtn {
                        width: 120px;
                        height: 44px;
                    }
                }
            }
        }
    }
</style>
